import { useEffect, useState } from "react";
import { Head, Link, useForm } from "@inertiajs/react";
import TextInput from "@/Components/TextInput";
import InputError from "@/Components/InputError";

export default function Login({ status, canResetPassword }) {
    const { data, setData, post, processing, errors, reset } = useForm({
        email: "",
        password: "",
        remember: false,
    });

    useEffect(() => {
        return () => {
            reset("password");
        };
    }, []);

    const submit = (e) => {
        e.preventDefault();
        console.log("Login attempt started");
        localStorage.setItem('loginStartTime', Date.now());
        post(route("login"))
    };

    return (
        <>
            <Head title="Log-In" />
            {/* BEGIN #app */}
            <div id="app" className="app app-full-height app-without-header">
                {/* BEGIN login */}
                <div className="login">
                    {/* BEGIN login-content */}
                    <div className="login-content">
                        <form
                            onSubmit={submit}
                            method="POST"
                            name="login_form"
                        >
                            <h1 className="text-center">Sign In</h1>
                            <div className="text-body text-opacity-50 text-center mb-5">
                                For your protection, please verify your
                                identity.
                            </div>
                            <div className="mb-4">
                                <label className="form-label">
                                    Email Address
                                </label>
                                <TextInput
                                    type="text"
                                    className="form-control form-control-lg fs-14px"
                                    placeholder="username@address.com"
                                    value={data.email}
                                    onChange={(e) => setData("email", e.target.value)}
                                />

                                <InputError message={errors.email} className="mt-2" />
                            </div>
                            <div className="mb-5">
                                <div className="d-flex">
                                    <label className="form-label">
                                        Password
                                    </label>
                                    <a
                                        href="#"
                                        className="ms-auto text-body text-opacity-50"
                                    >
                                        Forgot password?
                                    </a>
                                </div>
                                <TextInput
                                    type="password"
                                    className="form-control form-control-lg fs-14px"
                                    placeholder="Enter your password"
                                    value={data.password}
                                    onChange={e => setData("password", e.target.value)}
                                />

                                <InputError message={errors.password} className="mt-2" />
                            </div>
                            <button
                                type="submit"
                                className={"btn btn-theme btn-lg d-block w-100 mb-3 "+(processing ? "disabled" : "")}
                            >
                                { processing ? "Please Wait ..." : "Log In" }
                            </button>
                        </form>
                    </div>
                    {/* END login-content */}
                </div>
                {/* END login */}
            </div>
            {/* END #app */}
        </>
    );
}
